/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanAssetListItemResponseDto
 */
export interface PlanAssetListItemResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PlanAssetListItemResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlanAssetListItemResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof PlanAssetListItemResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof PlanAssetListItemResponseDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlanAssetListItemResponseDto
     */
    siteName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlanAssetListItemResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PlanAssetListItemResponseDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlanAssetListItemResponseDto
     */
    assignedAt: Date;
}

/**
 * Check if a given object implements the PlanAssetListItemResponseDto interface.
 */
export function instanceOfPlanAssetListItemResponseDto(value: object): value is PlanAssetListItemResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('assignedAt' in value) || value['assignedAt'] === undefined) return false;
    return true;
}

export function PlanAssetListItemResponseDtoFromJSON(json: any): PlanAssetListItemResponseDto {
    return PlanAssetListItemResponseDtoFromJSONTyped(json, false);
}

export function PlanAssetListItemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanAssetListItemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetId': json['assetId'],
        'assetName': json['assetName'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'active': json['active'],
        'startDate': (new Date(json['startDate'])),
        'assignedAt': (new Date(json['assignedAt'])),
    };
}

export function PlanAssetListItemResponseDtoToJSON(json: any): PlanAssetListItemResponseDto {
    return PlanAssetListItemResponseDtoToJSONTyped(json, false);
}

export function PlanAssetListItemResponseDtoToJSONTyped(value?: PlanAssetListItemResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetId': value['assetId'],
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'siteName': value['siteName'],
        'active': value['active'],
        'startDate': value['startDate'].toISOString(),
        'assignedAt': value['assignedAt'].toISOString(),
    };
}

